import CONFIG_JSON from "@/config";

export default CONFIG_JSON;
